// extracted by mini-css-extract-plugin
export default {"section":"section__SuO7lDeP","btn":"btn__MZCFCbGA","label":"label__uVyqj8jR","content":"content__T7S5ZfEA"};